import { SxProps, Theme } from '@mui/material/styles';

import { scrollContainerSx } from 'src/common/styles/scrollbarStyles';

/** Flex column root for dashboard list pages (header + toolbar + scrollable body). */
export const dashboardPageRootSx: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  flex: '1 1 0',
  minHeight: 0,
  overflow: 'hidden',
};

/** Scroll region layout on dashboard list pages (thin scrollbar is global via CssBaseline). */
export const dashboardScrollContainerSx = scrollContainerSx;

/** Top padding for dashboard content inside PageWrapper Container. */
export const dashboardPageContainerPtSx = { xs: 1, sm: 2 } as const;

/** Bottom padding for dashboard content inside PageWrapper Container. */
export const dashboardPageContainerPbSx = { xs: 1.5, sm: 2 } as const;

/**
 * Main dashboard page scroll region: breadcrumbs + title scroll away;
 * the filter toolbar sticks to the top of this element.
 */
export const dashboardPageScrollRegionSx: SxProps<Theme> = {
  ...scrollContainerSx,
  flex: '1 1 0',
  minHeight: 0,
  overflowY: 'auto',
  pb: 2,
};

/** Sticky shell around DashboardPageToolbar (page background so content does not show through). */
export const dashboardStickyToolbarSx: SxProps<Theme> = {
  position: 'sticky',
  top: 0,
  zIndex: theme => theme.zIndex.appBar,
  bgcolor: 'background.default',
  pt: { xs: 0, sm: 2 },
  pb: { xs: 1, sm: 2 },
};

/**
 * Body under a sticky toolbar on fill-style pages (tables / virtualized lists).
 * Tall enough that the title can scroll away while leaving a usable content viewport.
 */
export const dashboardPageFillBodySx: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  flex: '1 0 auto',
  minHeight: { xs: 'calc(100dvh - 10rem)', sm: 'calc(100dvh - 12rem)' },
  width: '100%',
};
